import React from 'react';
import { ICompanyResponse } from '../../../../../Interfaces/responseTypes';
import styles from './businessProfile.module.scss';
import useBusinessProfile from './businessProfile-hook';

export interface IBusinessProfileProps {
    data: ICompanyResponse;
    onUpdate: () => void
}

const BusinessProfile: React.FC<IBusinessProfileProps> = (props) => {
    const {
        navRef,
        navItemRefs,
        activeContent,
        PAGE_CONTENTS,
        handleNavClick,
        businessProfileActions,
    } = useBusinessProfile(props)
    return (
        <div className={styles.container}>
            <div className={styles.page}>
                <div className={styles.businessProfileHeader} ref={navRef}>
                    {
                        businessProfileActions.map((action, index) => {
                            return (
                                <div
                                    key={action.id}
                                    className={activeContent === action.id ? styles.selectedAction : styles.actionItem}
                                    onClick={()=>handleNavClick(index,action.id)}
                                    ref={(el) => (navItemRefs.current[index] = el)}
                                >
                                    <img src={action.icon} alt={`${action.icon}.svg`} />
                                    <p>{action.title}</p>
                                </div>
                            )
                        })
                    }
                </div>
                <div className={styles.pageContent}>
                    {PAGE_CONTENTS[activeContent]}
                </div>
            </div>
        </div>
    )
}

export default BusinessProfile
